export default "<div appTheme>\n    <router-outlet></router-outlet>\n</div>"